export enum Locale {
    En = 'en',
    No = 'no'
}